/**
 * External dependencies
 */
import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Box, Text, Stack } from '@towersystems/towersystems-design-system';
import { map, get, includes, remove } from 'lodash';

/**
 * Internal dependencies
 */
import Modal from 'components/modal';
import { createCloseModalAction } from 'state/ui/actions';
import { isModalVisible } from 'state/ui/selectors';
import { getResourceId } from 'state/ui/sync-resource/selectors';
import Preloader from 'components/preloader';
import { requestResource } from 'state/resources/actions';
import cecSdk from 'lib/customer-ec-sdk';

/**
 * Style dependencies
 */
import './styles.scss';

const SyncResourceModal = ({ isVisible, resourceId, close, ...props }) => {
    
    const [submitting, setSubmitting] = useState(false);
    const [requesting, setRequesting] = useState(true);
    const [resource, setResource] = useState(null);
    const [checkedConnections, setCheckedConnections] = useState([]);

    const [currentStep, setCurrentStep] = useState(1);

    // this class might get changed to be managed by redux
    useEffect(() => {
        if (!resourceId) {
            close();
            return;
        }
        loadResource(resourceId);
        setCheckedConnections([]);
    }, [resourceId]);

    const loadResource = async (resourceId) => {
        setRequesting(true);
        setResource(null);
        try {
            let resource = await props.requestResource(resourceId);
            setResource(resource);
            setRequesting(false);
        } catch (error) {
            close(); // add error handling
        }
    };

    const handleOnCheck = (e) => {
        let checkedId = e.target.value;
        let cChecked = [...checkedConnections];

        if (!includes(checkedConnections, checkedId)) {
            cChecked.push(checkedId);
        } else {
            cChecked = remove(cChecked, checkedId);
        }

        setCheckedConnections(cChecked);
    };

   

    const handleSubmit =  async () => {
        setSubmitting(true);

        for (var i = checkedConnections.length - 1; i >= 0; i--) {
            try {
                await cecSdk.resourceConnect(checkedConnections[i]).sync();
            } catch (error) {
                console.log(error);
            }
        }

       setSubmitting(false);
    }


    const buttons = [
        {
            key: 'cancel',
            label: 'Cancel',
            onClick: close,
        },
        {
            key: 'save',
            label: !submitting ? 'submit' : "submitting",
            form: 'create-connection-form',
            disabled: requesting || submitting,
            onClick: handleSubmit
        },
    ];

    return (
        <Modal
            title='Sync Resource'
            className='sync-resurce-modal'
            close={close}
            isVisible={isVisible}
            buttons={buttons}
        >
            <Box padding='large'>
                {(!resourceId || !resource) && <Preloader />}
                <Text>Select what connections you would like to send resource to.</Text>
                {resource && (
                    <Stack space='large'>
                        {map(resource.connects, (connect) => {

                            return (
                                <Box component='label' padding='large' flexDirection='column'>
                                    <Box alignItems='center' display='flex'>
                                        <input
                                            type='checkbox'
                                            value={connect.id}
                                            onClick={handleOnCheck}
                                            checked={includes(checkedConnections, connect.id)}
                                        />
                                        <Text>{get(connect, 'connection.connection_type_code')}</Text>
                                    </Box>
                                    <Text size="small">Last synced: {get(connect, 'last_synced')}</Text>
                                </Box>
                            );
                        })}
                    </Stack>
                )}
            </Box>
        </Modal>
    );
};

export default connect(
    (state) => ({
        isVisible: isModalVisible('SyncResourceModal')(state),
        resourceId: getResourceId(state),
    }),
    {
        close: createCloseModalAction('SyncResourceModal'),
        requestResource,
    },
)(SyncResourceModal);
